import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_ALARM_CONFIG_SAVE } from './url-constants';

type ManageAlarmsConfigSaveEndpointSpecification = ApiEndpointSpecification;
export const ManageAlarmsConfigSaveEndpointSpecification: ManageAlarmsConfigSaveEndpointSpecification = {
    url: MANAGE_ALARM_CONFIG_SAVE,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'ManageAlarmsConfigSaveRequestParams',
    requestBodySchemaName: 'ManageAlarmsConfigSaveRequestBody',
    okResponseSchemaName: 'ManageAlarmsConfigSaveOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageAlarmsConfigSave = Helpers.makeApiRequestFn<
    Types.ManageAlarmsConfigSaveRequestParams,
    Types.ManageAlarmsConfigSaveRequestBody,
    Types.ManageAlarmsConfigSaveOkResponse
>(ManageAlarmsConfigSaveEndpointSpecification);
